import { render, staticRenderFns } from "./StaffScanTemperature.vue?vue&type=template&id=1ccba936&scoped=true"
import script from "./StaffScanTemperature.vue?vue&type=script&lang=js"
export * from "./StaffScanTemperature.vue?vue&type=script&lang=js"
import style0 from "./StaffScanTemperature.vue?vue&type=style&index=0&id=1ccba936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccba936",
  null
  
)

export default component.exports